import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

export function useDropdownMenus() {
  const [currentDropdownMenu, setCurrentDropdownMenu] = useState<string | null>(
    null,
  );

  function openDropdown(menu: string) {
    setCurrentDropdownMenu(menu);
  }

  const closeDropdown = useCallback(() => {
    setCurrentDropdownMenu(null);
  }, []);

  // 라우터 이동 시 드롭다운 닫기
  const router = useRouter();
  useEffect(() => {
    router.events.on('routeChangeComplete', closeDropdown);
    return () => {
      router.events.off('routeChangeComplete', closeDropdown);
    };
  }, [router.events, closeDropdown]);

  return { currentDropdownMenu, openDropdown, closeDropdown };
}
